import { gsap } from 'gsap';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';

gsap.registerPlugin(MorphSVGPlugin, MotionPathPlugin);

document.addEventListener('DOMContentLoaded', () => {
  // define elements
  const root = document.querySelector(':root');
  const list = document.getElementById('country-set');
  const listItems = list.getElementsByClassName('svg-tween');
  const track = document.getElementById('track');
  const trackSvg = track.firstElementChild;
  const trackCircle = document.getElementById('track-circle');
  const overlayBg = document.getElementById('overlay-bg');

  // define variables
  const animationOpts = {
    duration: 0.75,
    ease: 'elastic.out(1, 0.6)',
    paused: true
  };

  // define helpers
  const partitionPaths = paths => {
    return Array.from(paths).reduce(
      (result, path) => {
        result[path.classList.contains('morph-from') ? 0 : 1].push(path);
        return result;
      },
      [[], []]
    );
  };

  const getFillColor = path => path.getAttribute('fill');

  // GREENSOCK STUFF

  // give the track a fixed size and convert it to a <path> element for consumption by MotionPathPlugin
  const trackRadius = track.offsetHeight / 2;
  trackCircle.setAttribute('cx', trackRadius);
  trackCircle.setAttribute('cy', trackRadius);
  trackCircle.setAttribute('r', trackRadius);
  MotionPathPlugin.convertToPath('#track-circle');

  // attach animations
  let bgTimeout;
  const allOverlays = Array.from(listItems).map(listItem => listItem.nextElementSibling);

  for (const [i, listItem] of Array.from(listItems).entries()) {
    // calculate rotation for overlay bg
    // we do this here b/c gradient direction is a function of position, determined by greensock
    const rotation = `${(i / listItems.length) - 0.25}turn`;

    // position country
    gsap.to(listItem, {
      motionPath: {
        path:  '#track-circle',
        align: '#track-circle',
        start: -0.25,
        end: (i / listItems.length),
        alignOrigin: [0.5, 0.5]
      },
      duration: 1
    });

    // build morph animation
    const paths = listItem.firstElementChild.getElementsByTagName('path');
    const [[fromSvg], [toSvg]] = partitionPaths(paths);

    // let tween = gsap.to('#path-greenland', { morphSVG: { duration: 1, shape: '#path-fish', shapeIndex: 3 }});
    let tween = gsap.to(fromSvg, {
      morphSVG: toSvg,
      fill: getFillColor(toSvg),
      ...animationOpts
    });

    // define handlers
    const overlay = listItem.nextElementSibling;
    const timeoutDelay = 500;
    let overlayTimeout;

    const clearAllOverlays = () => allOverlays.forEach(o => o.classList.remove('selected'));

    const handlerOn = e => {
      clearTimeout(bgTimeout);
      clearTimeout(overlayTimeout);
      clearAllOverlays();
      root.style.setProperty('--bg-rotation', `rotate(${rotation})`);
      tween.timeScale(1).play();
      overlay.classList.add('selected');
      track.classList.add('bg-active');
    };
    const handlerOff = e => {
      tween.timeScale(2).reverse();
      overlayTimeout = window.setTimeout(() => {
        overlay.classList.remove('selected');
        clearTimeout(overlayTimeout);
      }, timeoutDelay);
      bgTimeout = window.setTimeout(() => {
        track.classList.remove('bg-active');
        clearTimeout(bgTimeout);
      }, timeoutDelay);
    };

    // attach handlers
    listItem.addEventListener('mouseenter', handlerOn);
    listItem.addEventListener('mouseleave', handlerOff);
  }
});
